export const TIMESTAMP_TOOLTIP_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss' as const

export const TIMESTAMP_TRANSACTION_DATETIME_FORMAT = 'MMM-DD-YYYY HH:mm:ss A' as const

export const CSV_TIMESTAMP_FORMAT = 'YYYY-MM-DD HH:mm:ss' as const
